/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import styled from 'styled-components';

import colors from '../../../styles/colors';
import rainbowLine from '../../../assets/images/rainbow.svg';
import { ApplicationConstants } from '../../../constants/application';

export const Container = styled.nav`
  width: 100%;
  height: 90px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  position: fixed;
  top: 0;
`;

export const Background = styled.div`
  background: ${colors.white};

  display: flex;
  align-items: center;
  justify-content: flex-start;

  padding: 30px;

  width: 100%;
  height: 86px;
`;

export const ContainerLogo = styled.img.attrs({
  src: ApplicationConstants.SAAS_LOGO,
})`
  max-height: 50px;
`;

export const RainbowLine = styled.img.attrs({
  src: rainbowLine,
})`
  width: 110%;
`;
